import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import {
  handleRequest,
  handleRequestError,
  handleResponse,
  handleResponseError,
} from './interceptors'

export default abstract class HttpClient {
  private readonly instance: AxiosInstance

  protected constructor(config: AxiosRequestConfig) {
    this.instance = axios.create(config)
    // @ts-ignore
    this.instance.interceptors.request.use(handleRequest(), handleRequestError)

    this.instance.interceptors.request.use((cfg) => {
      if (cfg && cfg.url && cfg.url[cfg.url.length - 1] !== '/') {
        cfg.url += '/'
      }
      return cfg
    })

    this.instance.interceptors.response.use(handleResponse(), handleResponseError(this.instance))
  }

  public getUri(config?: AxiosRequestConfig): string {
    return this.instance.getUri(config)
  }

  public request<T, R = AxiosResponse<T>>(config: AxiosRequestConfig): Promise<R> {
    return this.instance.request(config)
  }

  public get<T, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.instance.get(url, config)
  }

  public delete<T, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.instance.delete(url, config)
  }

  public head<T, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.instance.head(url, config)
  }

  public post<T, D, R = AxiosResponse<T>>(
    url: string,
    data: D,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.instance.post(url, data, config)
  }

  public put<T, D, R = AxiosResponse<T>>(
    url: string,
    data: D,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.instance.put(url, data, config)
  }

  public patch<T, R = AxiosResponse<T>>(
    url: string,
    data?: string,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.instance.patch(url, data, config)
  }
}
